
import { Component, Input, Output, EventEmitter, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { SiriusUiBaseComponent } from 'sirius-framework';

declare const $: any;

@Component({
    selector: 'ui-documentviewer',
    template: `<div class="sirius-documentviewer">
                    <div class="sirius-documentviewer-holder" #holder>
                       <img *ngFor="let doc of srDocumentList" class="sirius-documentviewer-image" [src]="doc" />
                   </div>
                   <span *ngIf="showMessage()" class="sr-validation-message">{{srEmptyMessage}}</span>
               </div>`
})
export class UiDocumentViewerComponent extends SiriusUiBaseComponent implements AfterViewInit {
    @ViewChild('holder') elmHolder: ElementRef;

    private documentList: Array<string>;
    private documentId: string;
    private documentCompleted = false;
    private zoomEnabled = false;

    private emptyMessageResourceKey: string;
    private emptyMessageResourceType: string;
    private emptyMessage: string;
     

    constructor() {
        super();
    }

    OnInit() {
        this.setEmptyMessageValue();
    }

    ngAfterViewInit() {
        this.enableZoom();
    }

    showMessage(): boolean {
        return this.srDocumentList == null && this.srDocumentCompleted;
    }

    public get srDocumentList(): Array<string> {
        return this.documentList;
    }

  

    @Input()
    public set srDocumentListOut(value: Array<string>) { 
        this.documentList = value;
        this.loadDocumentList()
    }

 

    public get srDocumentCompleted(): boolean {
        return this.documentCompleted;
    }

    public get srZoomEnabled(): boolean {
        return this.zoomEnabled;
    }

    @Input()
    public set srZoomEnabled(value: boolean) {
        if (this.zoomEnabled == value) {
            return;
        }
        this.zoomEnabled = value;
    }

    public get srEmptyMessageResourceKey(): string {
        return this.emptyMessageResourceKey;
    }

    @Input()
    public set srEmptyMessageResourceKey(value: string) {
        if (this.emptyMessageResourceKey == value) {
            return;
        }
        this.emptyMessageResourceKey = value;
        this.setEmptyMessageValue();
    }

    public get srEmptyMessageResourceType(): string {
        return this.emptyMessageResourceType;
    }

    @Input()
    public set srEmptyMessageResourceType(value: string) {
        if (this.emptyMessageResourceType == value) {
            return;
        }
        this.emptyMessageResourceType = value;
        this.setEmptyMessageValue();
    }

    public get srEmptyMessage(): string {
        return this.emptyMessage;
    }

    @Input()
    public set srEmptyMessage(value: string) {
        if (this.emptyMessage == value) {
            return;
        }
        this.emptyMessage = value;
    }

    @Output() srDocumentLoaded: EventEmitter<Array<string>> = new EventEmitter();

    private getResourceValue(resourceKey: string, resourceType: string, uiCulture: string = "tr-TR") {
        return this.resourceService.getResource(resourceKey, resourceType, uiCulture);
    }

    private setEmptyMessageValue() {
        if (this.srEmptyMessageResourceKey != undefined && this.srEmptyMessageResourceType != undefined)
            this.srEmptyMessage = this.getResourceValue(this.srEmptyMessageResourceKey, this.srEmptyMessageResourceType);
    }

    private loadDocumentList() {
        let documentExists = this.hasValue();
        if (!documentExists) {
            return;
        } 
       
        this.documentCompleted = true;
        this.srDocumentLoaded.emit(this.documentList);
        
    }

    private hasValue(): boolean {
        return this.documentList != null && this.documentList != undefined ;
    }

    private enableZoom(): void {
        if (!this.srZoomEnabled)
            return;
        try {
            $(this.elmHolder.nativeElement).css("width", "auto");
            $(this.elmHolder.nativeElement).pinchzoomer({
                crop: false,
                appendControlHolder: false,
                appendControls: false,
                adjustHolderSize: false,
                preserveScale: true,
                useRealZoom: true,
                fullscreenScaleMode: "none",
                scaleMode: "none",
                preloaderUrl: null
            });
        }
        catch (zoomerException) {
            this.logService.error("An error occured while initializing pinchzoomer.", zoomerException);
        }
    }
}
